import AssetSizeRule from '../AssetSizeRule';

class ImageSizeOverridePolicy {
  #assetSizeRule: AssetSizeRule;
  constructor(assetSizeRule: AssetSizeRule) {
    this.#assetSizeRule = assetSizeRule;
  }

  overrideDefaultSelection(offerSize: string): boolean {
    return this.#assetSizeRule.containsOfferSize(offerSize);
  }
}

export default ImageSizeOverridePolicy;
